<template>
    <div v-if="changePassword" class="change-password-container">
      <div class="change-password-box">
        <h2 class="title has-text-centered">Changement de mot de passe</h2>
        <p class="subtitle has-text-centered">Veuillez créer un nouveau mot de passe</p>
        
        <form @submit.prevent="updatePassword">
          <div class="field">
            <b-field>
              <b-input
                type="password"
                placeholder="Nouveau mot de passe"
                icon-pack="fas"
                v-model="newPassword"
                password-reveal
                size="is-large"
              ></b-input>
            </b-field>
          </div>
          
          <div class="field">
            <b-field>
              <b-input
                type="password"
                placeholder="Confirmer le mot de passe"
                icon-pack="fas"
                v-model="confirmPassword"
                password-reveal
                size="is-large"
              ></b-input>
            </b-field>
          </div>
          
          <p v-if="passwordsDoNotMatch" class="has-text-weight-light has-text-danger is-size-6">
            Les mots de passe ne correspondent pas.
          </p>
          
          <p v-if="passwordTooShort" class="has-text-weight-light has-text-danger is-size-6">
            Le mot de passe doit contenir au moins 8 caractères.
          </p>
          
          <p v-if="changePasswordError" class="has-text-weight-light has-text-danger is-size-6">
            Une erreur est survenue lors du changement de mot de passe. Veuillez réessayer.
          </p>
          
          <div class="field">
            <button 
              type="submit" 
              class="button is-primary is-fullwidth is-large buttonConnexion"
              :disabled="isUpdateDisabled"
              :class="{'is-loading': isUpdating}"
            >
              Changer mon mot de passe
            </button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import Parse from "parse";
  import ParseConfig from "@/api/parse.config";
  
  export default {
    props: {
      changePassword: {
        type: Boolean,
        default: false
      },
      email: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        newPassword: "",
        confirmPassword: "",
        passwordsDoNotMatch: false,
        passwordTooShort: false,
        changePasswordError: false,
        isUpdating: false
      };
    },
    computed: {
      isUpdateDisabled() {
        return !this.newPassword || !this.confirmPassword || this.isUpdating;
      }
    },
    methods: {
      async updatePassword() {
        this.passwordsDoNotMatch = false;
        this.passwordTooShort = false;
        this.changePasswordError = false;
        
        // Vérifier si les mots de passe correspondent
        if (this.newPassword !== this.confirmPassword) {
          this.passwordsDoNotMatch = true;
          return;
        }
        
        // Vérifier la longueur minimale du mot de passe
        if (this.newPassword.length < 8) {
          this.passwordTooShort = true;
          return;
        }
        
        try {
          this.isUpdating = true;
          ParseConfig();
          
          // Récupérer les paramètres d'URL
          const urlParams = new URLSearchParams(window.location.search);
          const email = urlParams.get("email") || this.email;
          const token = urlParams.get("token");
          
          // Appel au service Cloud pour changer le mot de passe
          const result = await Parse.Cloud.run("resetPassword", {
            email: decodeURIComponent(email),
            token: token,
            newPassword: this.newPassword
          });
          
          if (result.status === "success") {
            // Réinitialiser les champs
            this.newPassword = "";
            this.confirmPassword = "";
            
            // Afficher un message de succès
            this.$buefy.toast.open({
              message: "Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter.",
              type: "is-success",
              duration: 5000
            });
            
            // Rediriger vers la page de connexion après un court délai
            setTimeout(() => {
              this.$emit("password-changed");
              // Supprimer les paramètres d'URL
              window.history.replaceState(null, null, window.location.pathname);
            }, 2000);
          } else {
            this.changePasswordError = true;
          }
        } catch (error) {
          console.error("Erreur lors du changement de mot de passe:", error);
          this.changePasswordError = true;
        } finally {
          this.isUpdating = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .change-password-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .change-password-box {
    background-color: white;
    border-radius: 8px;
    padding: 2rem;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  }
  
  .title {
    color: #4a4a4a;
    margin-bottom: 1rem;
  }
  
  .subtitle {
    color: #7a7a7a;
    margin-bottom: 2rem;
  }
  
  .field {
    margin-bottom: 1.5rem;
  }
  
  .buttonConnexion {
    margin-top: 1rem;
  }
  </style>